import { Label } from "@components/ui/label";
import {
  RadioGroup as UIRadioGroup,
  RadioGroupItem,
} from "@components/ui/radio-group";
import { SingleValueFilterOption } from "@lib/utils/types/filters";
import { OnSelect } from "@lib/utils/types/filters/OnSelect";
import { useTransition } from "react";

interface IRadioGroup {
  values: SingleValueFilterOption[];
  clearLabel?: string;
  onSelect: (v: OnSelect) => void;
  selectedValue: string;
}

export function RadioGroup({
  values,
  clearLabel,
  onSelect,
  selectedValue,
}: IRadioGroup) {
  const [_, startTransition] = useTransition();
  return (
    <UIRadioGroup
      onValueChange={e => {
        startTransition(() => {
          onSelect({
            name: values[0].name,
            value: e,
            type: "single",
          });
        });
      }}
      value={selectedValue || ""}
      defaultValue={selectedValue || ""}
      className="space-y-3 py-3"
    >
      {clearLabel && (
        <div key="clear" className="flex items-center space-x-2">
          <RadioGroupItem value={""} id={clearLabel} />
          <Label htmlFor={clearLabel}>{clearLabel}</Label>
        </div>
      )}
      {values.map(({ id, value, label }) => (
        <div key={id} className="flex items-center space-x-2">
          <RadioGroupItem value={value} id={value} />
          <Label htmlFor={value}>{label}</Label>
        </div>
      ))}
    </UIRadioGroup>
  );
}
